/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import {
  ChevronLeftIcon,
  ChevronRightIcon
} from "@dotnet/telematics-design-system";

import Button from "../../../../../../Button/Button";
import { useStyles } from "../../../../../styles";

interface TabsArrowButtonProps {
  onButtonClick: () => void;
  isDisabled: boolean;
  leftButton?: boolean;
}

const TabsArrowButton = ({
  onButtonClick,
  isDisabled,
  leftButton
}: TabsArrowButtonProps) => {
  const {
    leftTabsArrowButton,
    rightTabsArrowButton,
    customTabsArrowButtonBorder
  } = useStyles();

  const buttonStyle = leftButton ? leftTabsArrowButton : rightTabsArrowButton;
  const icon = leftButton ? (
    <ChevronLeftIcon data-testid="left-arrow-icon" />
  ) : (
    <ChevronRightIcon data-testid="right-arrow-icon" />
  );

  return (
    <Button
      data-testid="tabs-arrow-button"
      onClick={onButtonClick}
      variant="iconOnly"
      icon={icon}
      color="secondary"
      size="small"
      disabled={isDisabled}
      css={css([buttonStyle, customTabsArrowButtonBorder])}
    />
  );
};

export default TabsArrowButton;
